module.exports = __webpack_public_path__ + "static/media/DESCARGA_E_IMPRIME_EL_ANVERSO_Y_REVERSO_L1_HASHTAG_MAGICO.8520c855.pdf";